<template>
    <div id="dialog-add-edit-apiary-widget-component">
        <v-dialog v-model="is_dialog_add_edit_apiary_open" max-width="600px">
            <v-card>
                <v-form ref="form">
                    <v-card-title>
                        <p class="text-uppercase font-18 font-weight-bold mb-2">
                            {{ $t('global_apiary.add_apiary') }}
                        </p>
                    </v-card-title>

                    <v-card-text class="pb-0">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="apiary.name" :label="$t('global_apiary.name_apiary')"
                                    :rules="[rules.required]" filled
                                />

                                <v-select
                                    v-model="apiary.id_hives"
                                    :loading="loading_assets_not_link"
                                    :items="assets_not_link"
                                    :label="$t('global_apiary.hives')"
                                    filled
                                    multiple
                                    item-text="name"
                                    item-value="id_asset"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                        <v-btn text @click="is_dialog_add_edit_apiary_open = false">
                            <span class="font-color-light font-weight-bold">{{ $t('global.cancel') }}</span>
                        </v-btn>

                        <v-btn :loading="loading_add_edit_apiary" color="secondary" text
                               @click="prepareAddEditApiary()">
                            <span class="secondary--text font-weight-bold">{{ $t('global.validate') }}</span>
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ClientRepository from '@/repositories/ClientRepository'
import ApiaryRepository from '@/repositories/ApiaryRepository'

export default {
    name: 'AddEditApiaryDialogComponent',
    data() {
        return {
            is_dialog_add_edit_apiary_open: false,
            loading_assets_not_link: false,
            assets_not_link: [],
            apiary: {},
            rules: {
                required: (value) => !!value || this.$t('global.field_required'),
            },
            loading_add_edit_apiary: false,
        }
    },
    methods: {
        openDialogAddEditApiary(apiary) {
            if(apiary) {
                this.apiary = apiary
            } else {
                if(this.$refs.form) {
                    this.$refs.form.reset()
                }
                this.apiary = {}
            }

            this.getAssetNotLinkToApiaryByIdClient()
            this.is_dialog_add_edit_apiary_open = true
        },

        getAssetNotLinkToApiaryByIdClient() {
            this.loading_assets_not_link = true

            ClientRepository.getAssetNotLinkToApiaryByIdClient(this.$auth.user().id_client).then(response => {
                this.assets_not_link = response.data.data
                Object.assign(this.apiary, {
                    id_hives: []
                });

                this.apiary.hives.forEach((hive) => {
                    this.apiary.id_hives.push(hive.id_asset)
                    this.assets_not_link.push(hive)
                })
            }).catch((error) => {
                this.manageError(error)
            }).finally(() => {
                this.loading_assets_not_link = false
            })
        },

        prepareAddEditApiary() {
            if(!this.apiary.id_apiary) {
                this.addApiary();
            } else {
                this.updateApiary();
            }
        },

        addApiary() {
            if (this.$refs.form.validate()) {
                this.loading_add_edit_apiary = true

                ApiaryRepository.postAddApiary(this.apiary).then(response => {
                    this.showSnackbar('success', this.$t('global_apiary.apiary_added'))
                    this.is_dialog_add_edit_apiary_open = false
                    this.$emit('apiaryAdded', response.data.data)
                }).catch(error => {
                    this.manageError(error)
                }).finally(() => {
                    this.loading_add_edit_apiary = false
                })
            }
        },

        updateApiary() {
            if (this.$refs.form.validate()) {
                this.loading_add_edit_apiary = true

                ApiaryRepository.putUpdateApiary(this.apiary).then(response => {
                    this.showSnackbar('success', this.$t('global_apiary.apiary_updated'))
                    this.is_dialog_add_edit_apiary_open = false
                    this.$emit('apiaryUpdated', response.data.data)
                }).catch(error => {
                    this.manageError(error)
                }).finally(() => {
                    this.loading_add_edit_apiary = false
                })
            }
        }
    }
}
</script>